import { datadogRum } from '@wehunt/core-web'
import type { NpsCancelMethod } from '@wehunt/ui'

// Event names and property names are mobile's, verbatim, so the two platforms'
// data has one schema even though it currently lands in two sinks (Datadog RUM
// here, Mixpanel on mobile).
const PLATFORM = 'web'

/** Same cuts as npsCategory in @wehunt/ui and mobile's nps_tracking.dart. */
function category(score: number): 'detractor' | 'passive' | 'promoter' {
  if (score <= 6) return 'detractor'
  if (score <= 8) return 'passive'
  return 'promoter'
}

export function trackNpsPromptShown(input: {
  daysSinceFirstLogin: number
  daysSinceLastFeedback: number | null
}): void {
  datadogRum.addAction('NpsPromptShown', {
    platform: PLATFORM,
    daysSinceWehuntFirstLogin: input.daysSinceFirstLogin,
    // Omitted rather than sent as null, matching mobile's conditional property
    // map — an absent property and "no previous feedback" read the same way, and
    // a null would show up as its own bucket in the funnel.
    ...(input.daysSinceLastFeedback !== null
      ? { daysSinceLastFeedback: input.daysSinceLastFeedback }
      : {}),
  })
}

export function trackNpsPromptSubmitted(input: { score: number; hasComment: boolean }): void {
  datadogRum.addAction('NpsPromptSubmitted', {
    platform: PLATFORM,
    score: input.score,
    category: category(input.score),
    hasComment: input.hasComment,
  })
}

export function trackNpsPromptDismissed(input: {
  method: NpsCancelMethod
  secondsShown: number
}): void {
  datadogRum.addAction('NpsPromptDismissed', {
    platform: PLATFORM,
    // Legacy Mixpanel vocabulary, so the property is directly comparable with
    // mobile's: the ✕ and Escape are both "cancel", skip is "back".
    dismissMethod: input.method === 'skip' ? 'backButton' : 'cancelButton',
    secondsShown: input.secondsShown,
  })
}
